<script>
import appConfig from '@/app.config'
import { Helper } from '@/mixin/helper';
import WebviewVideoList from './Video/Webview/WebviewVideoList.vue';
import { mapGetters, mapActions } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import * as devices from '@/services/rest-api-sms/lib/device/device'

export default {
  name: 'WebviewTrackvideo',
  page: {
    title: 'Webview',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  mixins: [Helper],

  components: {
    WebviewVideoList,
  },

  data() {
    return {
      search: {
        licensePlate: null,
      },
      dataByStatus: [],
      renderList: false,
    }
  },

  computed: {
    ...mapGetters('video', [
      'fleetsListFilter',
      'fleetsList',
    ]),
  },

  async created() {
    await this.getDeviceByParams()
    await this.loadData()
    this.startVideoStreaming()
  },

  mounted() {
  },

  methods: {
    ...mapActions('video', ['getTotalCamera', 'setVideoStreamStatus']),

    async startVideoStreaming() {
      this.dataByStatus.forEach((row, index) => {
        this.connectToStreaming(row, index)
      })
    },

    async getDeviceByParams() {
      let payload = {
        filters: [`vehicle_id eq ${this.$route.params.id ?? ''}`],
        page: 1,
        limit: 1,
      }

      const deviceList = await devices.get(payload, this.selectedServerRegion)
      if (!deviceList?.data) {
        this.filteredItems = []
        this.totalRows = 0
        this.currentPage = 1
        this.perPage = 10
        this.totalPages = 1
        this.devices = []
        this.loading = false
        return
      }

      const device = deviceList.data.paginated_result;
      if (device.length > 0) {
        this.mapDeviceValue(device[0])
      }
    },

    mapDeviceValue(data) {
      let motionStatus = ''

      switch (data.motion_status) {
        case 'I':
          motionStatus = 'Diam'
          break
        case 'M':
          motionStatus = 'Bergerak'
          break
        case 'O':
          motionStatus = 'Offline'
          break
        default:
          motionStatus = 'Parkir'
          break
      }

      const device = {
        phoneNo: data.phone_no,
        deviceCode: data.device_code,
        deviceType: {
          deviceName: data.device_name,
        },
        deviceName: data.device_name,
        imei: data.imei,
        vehicle: {
          license_plate: data.license_plate,
          imei: data.imei,
          vehicle_id: data.vehicle_id,
          vehicle_status: {
            vehicle_motion_status: motionStatus,
          },
        },
      }

      // Set Data
      this.search.licensePlate = data.license_plate;
      localStorage.setItem('device', JSON.stringify(device))
    },

    async loadData() {
      this.$store.commit('video/loadingFleets', true)
      this.dataByStatus = []
      this.renderList = false

      await this.getTotalCamera({})

      this.dataByStatus = this.fleetsListFilter(this.search.licensePlate).map((data) => ({
        ...data,
        showInList: true,
      }))


      this.renderList = true
      this.$store.commit('video/loadingFleets', false)
    },

    async connectToStreaming(data) {
      const oldData = { ...data }
      data.oldPlaylist = oldData.tempPlaylist ?? []

      data.playlist = data.channel.map((x) => x.value)
      data.tempPlaylist = data.channel.map((x) => x.value)
      await this.$nextTick()

      data.oldPlaylistWithUid = oldData?.playlistWithUid ?? []
      await this.$nextTick()
      data.playlistWithUid = data.playlist.map((playlist) => {
        const isOldPlaylist = data.oldPlaylistWithUid.some((data) => data.playlist === playlist)
        if (isOldPlaylist) {
          return {
            playlist,
            uid: data.oldPlaylistWithUid.find((data) => data.playlist === playlist).uid,
          }
        }
        return { playlist, uid: uuidv4() }
      })

      const { channelSent, channelNotSent } = await this.setVideoStreamStatus(data)

      const isAllChannelNotSent =
        data.channel.length === data.playlist.length &&
        channelNotSent.length === data.channel.length &&
        channelSent.length === 0

      const deviceType = this.getDeviceType(data.vehicle.device.deviceCode)

      const isJc = deviceType === 'jc'
      if (isAllChannelNotSent) {

        await this.$nextTick()

        data.playlist = []
        data.tempPlaylist = []
        data.playlistWithUid = []
        data.oldPlaylist = oldData.oldPlaylist ?? []
        data.oldPlaylistWithUid = oldData.oldPlaylistWithUid ?? []
        this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
      }
      if (        
        channelNotSent.length &&
        channelNotSent.length < data.channel.length
      ) {
        const _playlist = channelSent.map(
          (channel) => `${data.vehicleId}:${isJc ? parseInt(channel) - 1 : channel}`
        )
        data.playlist = _playlist
        data.tempPlaylist = _playlist
        await this.$nextTick()
        data.playlistWithUid = data.playlistWithUid.filter((playlistUid) =>
          data.playlist.includes(playlistUid.playlist)
        )
        data.oldPlaylist = oldData.oldPlaylist ?? []
        data.oldPlaylistWithUid = oldData.oldPlaylistWithUid ?? []
        this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
      }
      this.$forceUpdate()
      this.$store.commit('video/setPlaylist', data)
    },
  },
}
</script>

<template>
  <WebviewVideoList ref="videoList" />
</template>
